// extracted by css-extract-rspack-plugin
export default {"NoticeRoot":"fEXBL","NoticeContent":"ExBHV","NoticeWarningIcon":"hq13B","NoticeCloseIcon":"TCU7A"};